/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentValidationResponseList {
    getFixupPrototypeFunction() { return AssessmentValidationResponseList.fixupPrototype; }

    static newInstance(model: Partial<AssessmentValidationResponseList>): AssessmentValidationResponseList {
        let obj = Object.assign(new AssessmentValidationResponseList(), model);
        AssessmentValidationResponseList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentValidationResponseList>): AssessmentValidationResponseList {
        if (!model) return null;
        return AssessmentValidationResponseList.newInstance(<AssessmentValidationResponseList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentValidationResponseList) {
        if (!obj) return;

        models.AssessmentValidationResponseList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentValidationResponseList): boolean {
        Object.setPrototypeOf(obj, AssessmentValidationResponseList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_validation_list) {
            for (let val of this.assessment_validation_list) {
                models.AssessmentValidationResponse.fixupPrototype(val);
            }
        }
    }

    /**
     * Assessment Validation data
     */
    assessment_validation_list: Array<models.AssessmentValidationResponse>;

}
